import { useEffect, useState } from 'react';

/**
 * Returns the current wall-clock time in ms and re-renders on a fixed interval.
 *
 * Use this to make time-based UI (e.g. "online within last 5 min", "last seen Xm ago")
 * re-evaluate on its own instead of only when some unrelated state changes. Without a
 * ticking clock, a device that goes silent can appear online indefinitely because the
 * freshness comparison never runs again.
 *
 * @param {number} intervalMs How often to tick (default 30s). Keep this coarse; freshness
 *   thresholds are on the order of minutes, so a fast tick just wastes renders.
 * @returns {number} Date.now() as of the latest tick.
 */
export function useNow(intervalMs = 30000) {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const id = setInterval(() => setNow(Date.now()), intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);

    return now;
}

export default useNow;
